/* eslint-disable */
const mockedPrices = {
    adultCount:1,
    childrenCount:1,
    infantCount:0,
    currency:'THB',
    prices:{
        adult:1500,
        child:1000,
    },
    taxes:{
        adult:750,
        child:600,
    },
    qSurcharge:{
        adult:0,
        child:0,
    },        
}

const mockedPrices2 = null;

export default  mockedPrices2;